import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import {
  Component,
  OnInit
} from '@angular/core';
import { Router } from '@angular/router';

interface DifficultyLevelPayload {
  name: string;
}

@Component({
  selector: 'app-add-difficulty-level',
  standalone: false,
  templateUrl: './add-difficulty-level.html',
  styleUrl: './add-difficulty-level.scss',
})
export class AddDifficultyLevel implements OnInit{
   pageTitle = 'Add New Difficulty Level';

  pageSubtitle =
    'Create and organize a new course difficulty level.';

  difficultyLevelForm!: FormGroup;

  isSubmitted = false;
  isSaving = false;

  private saveAnotherAfterSubmit = false;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.initializeForm();
  }

  get nameControl(): AbstractControl {
    return this.difficultyLevelForm.get(
      'name'
    ) as AbstractControl;
  }

  submitDifficultyLevel(): void {
    this.saveDifficultyLevel(false);
  }

  saveAndAddAnother(): void {
    this.saveDifficultyLevel(true);
  }

  private initializeForm(): void {
    this.difficultyLevelForm =
      this.formBuilder.group({
        name: [
          '',
          [
            Validators.required,
            Validators.maxLength(100),
            Validators.pattern(
              /^[A-Za-z\s-]+$/
            )
          ]
        ]
      });
  }

  private saveDifficultyLevel(
    saveAnother: boolean
  ): void {
    this.isSubmitted = true;
    this.saveAnotherAfterSubmit =
      saveAnother;

    if (
      this.difficultyLevelForm.invalid ||
      this.isSaving
    ) {
      this.difficultyLevelForm
        .markAllAsTouched();

      return;
    }

    const formValue =
      this.difficultyLevelForm
        .getRawValue();

    const payload:
      DifficultyLevelPayload = {
        name: formValue.name.trim()
      };

    this.isSaving = true;

    console.log(
      'Difficulty-level payload:',
      payload
    );

    /*
    Replace the timeout with your API:

    this.difficultyLevelService
      .createDifficultyLevel(payload)
      .pipe(
        finalize(() => {
          this.isSaving = false;
        })
      )
      .subscribe({
        next: () => {
          this.handleSaveSuccess();
        },
        error: (error) => {
          console.error(
            'Difficulty-level creation failed:',
            error
          );
        }
      });
    */

    setTimeout(() => {
      this.isSaving = false;
      this.handleSaveSuccess();
    }, 800);
  }

  private handleSaveSuccess(): void {
    this.isSubmitted = false;

    if (this.saveAnotherAfterSubmit) {
      this.resetForm();
      return;
    }

    this.router.navigate([
      '/admin/course-reference/difficulty-levels'
    ]);
  }

  private resetForm(): void {
    this.difficultyLevelForm.reset({
      name: ''
    });

    this.saveAnotherAfterSubmit = false;
  }
   cancel(): void {
   window.history.back();
  }

}
